import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Observable } from 'rxjs';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate.js';
import { ScrollContainerComponent } from '../../common/components/scroll.container/scroll.container.component';
import {
  FilterDateRangButtonComponent,
  FilterDateRange,
  FilterObject,
  FilterSelectObject,
  FilterSelectObjectComponent,
} from '../../common/filter';
import {
  ListOption,
  ScrollableListComponentBase,
} from '../../common/list.component.base';
import { WebUtils } from '../../common/utils';
import { XlsUtils } from '../../common/xls.utils';
import { AccessUtils, TClientAccessLog, TLocation } from '../../core/entities';
import { SiteFormatMixin } from '../../thinkdesks/site.format.mixin';
import { TDevice } from '../../thinkdesks/thinkdesks.entities';

class _Base extends ScrollableListComponentBase<TClientAccessLog> { }

@Component({
  selector: 'app-access-log-list',
  templateUrl: './access.log.list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ScrollContainerComponent,
    FontAwesomeModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    FilterDateRangButtonComponent,
    FilterSelectObjectComponent,
  ],
})
export class AccessLogListComponent extends SiteFormatMixin(_Base) {
  _common = _common;
  @HostBinding('class') css = 'max-height';

  filterObject = new FilterObject();
  dateRange = new FilterDateRange();
  memberFilter = new FilterSelectObject();

  //   status = new FilterMulti();

  //   type = new FilterMulti();

  displayedColumns: string[] = [
    'time',
    'member',
    'memberType',
    'admin',
    //'controls'
  ];

  @Input()
  device: TDevice;
  @Input()
  location: TLocation;
  constructor(
    override http: HttpClient,
    override elRef: ElementRef,
    private dialog: MatDialog,
    override snackBar: MatSnackBar
  ) {
    super(http, snackBar, elRef);
    this.filterObject.add('member', this.memberFilter);
    this.filterObject.add('dateRange', this.dateRange);
    this.pageSort = 'time';
    this.pageSortDir = 'desc';
  }
  createBaseQuery() {
    let query = {
      device: WebUtils.objId(this.device),
    } as any;
    Object.assign(query, this.filterObject.query());

    return query;
  }

  override createRequest(options: ListOption): Observable<Object> {
    let query = this.createBaseQuery();

    const url = this._listModifyUrl(`/api/access-log/list`, {}, options);
    return this.http.post(url, query);
  }

  override listFixList(list: TClientAccessLog[]) {
    for (let o of list) AccessUtils.fixClientAccessLog(o);
  }

  selectMember(filter: FilterSelectObject) {
    // let ref = this.dialog.open(OrganizationSearchComponent, {
    //   data: {
    //     multiple: false,
    //   },
    // });
    // ref.afterClosed().subscribe((result) => {
    //   if (result) {
    //     filter.set(result[0]);
    //     this.refresh();
    //   }
    // });
  }
  override selectObject(o: TClientAccessLog) { }

  exportList() {
    let query = this.createBaseQuery();

    WebUtils.web_list(
      this.http.post(`/api/access-log/list`, query),
      (result) => {
        let list = result as any[];
        for (let o of list) {
          AccessUtils.fixClientAccessLog(o);
        }

        this.doExport(list);
      }
    );
  }
  doExport(dataList: any[]) {
    XlsxPopulate.fromBlankAsync().then((workbook: XlsxPopulate.Workbook) => {
      const sheet = workbook.sheet('Sheet1');
      const now = new Date();
      const pad = (n: number) => n.toString().padStart(2, '0');
      const dateStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;
      this.exportSheet(sheet, dataList);
      XlsUtils.webExport(workbook, null, {
        filename: `Door_access_log_${this.location.name}_${dateStr}.xlsx`,
      });
    });
  }
  exportSheet(sheet: XlsxPopulate.Sheet, dataList: any) {
    let columnOrder = [
      {
        path: 'time',
        name: 'Unlock door at',
      },
      {
        path: 'device',
        name: 'Device Name',
      },
      // {
      //   path: 'space.id',
      //   name: 'Space Name',
      // },
      // {
      //   path: 'space',
      //   name: 'Space Name',
      // },
      // {
      //   path: 'location.name',
      //   name: 'Center (zh_hk)',
      // },
      // {
      //   path: 'location.name_lang.en',
      //   name: 'Center (en)',
      // },
      // {
      //   path: 'location.organization.name',
      //   name: 'Organization (zh_hk)',
      // },
      // {
      //   path: 'location.organization.name_lang.en',
      //   name: 'Organization (en)',
      // },

      {
        path: 'member.name',
        name: 'Member',
      },
      {
        path: 'member.userId',
        name: 'UUID',
      },
      {
        path: 'member.mobile',
        name: 'Mobile',
      },
      {
        path: 'member.email',
        name: 'Email',
      },
      {
        path: 'member.memberType.name',
        name: 'Member Type',
      },
      {
        path: 'admin',
        name: 'Unlock from Web (Y/N)',
      },
    ];

    // let columnOrder = this.columnOrder_Product;
    // switch (this.type) {
    //   case PSiteModule.event:
    //     columnOrder = this.columnOrder_Event;
    // }
    const header = columnOrder.map((column) => column.name);
    const cells = [
      // Header
      header,
    ];
    // Values
    for (const order of dataList) {
      const data = columnOrder.map((column) => {
        const columnKeys = column.path.split('.');
        let cell = order;
        //

        switch (column.path) {
          case 'admin':
            return cell.admin ? 'Y' : 'N';
          case 'device':
            return this.device?.name;
          case 'time':
            return this.formatTime(cell.time);
        }
        for (const columnKey of columnKeys) {
          if (!cell[columnKey]) return '';
          else cell = cell[columnKey];
        }
        return cell;
      });

      cells.push(data);
    }

    sheet.cell('A1').value(cells);
  }
}
